var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main" },
    [
      _c(
        "el-form",
        {
          ref: "ruleForm",
          staticClass: "mt20",
          attrs: {
            model: _vm.ruleForm,
            rules: _vm.rules,
            "label-width": "90px",
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "显示名称:", prop: "table_name" } },
            [
              _c("el-input", {
                attrs: { size: "small" },
                model: {
                  value: _vm.ruleForm.table_name,
                  callback: function ($$v) {
                    _vm.$set(_vm.ruleForm, "table_name", $$v)
                  },
                  expression: "ruleForm.table_name",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "实体名称:", prop: "table_name_en" } },
            [
              _c("el-input", {
                attrs: { disabled: "", size: "small" },
                model: {
                  value: _vm.ruleForm.table_name_en,
                  callback: function ($$v) {
                    _vm.$set(_vm.ruleForm, "table_name_en", $$v)
                  },
                  expression: "ruleForm.table_name_en",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "所属主实体:", prop: "region" } },
            [
              _c("el-cascader", {
                staticStyle: { width: "100%" },
                attrs: {
                  disabled: "",
                  options: _vm.options,
                  size: "small",
                  "show-all-levels": false,
                  props: {
                    checkStrictly: true,
                    label: "table_name",
                    value: "id",
                    emitPath: false,
                  },
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var node = ref.node
                      var data = ref.data
                      return [
                        _c("span", [_vm._v(_vm._s(data.table_name))]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(" （" + _vm._s(data.table_name_en) + "）"),
                        ]),
                      ]
                    },
                  },
                ]),
                model: {
                  value: _vm.ruleForm.crud_id,
                  callback: function ($$v) {
                    _vm.$set(_vm.ruleForm, "crud_id", $$v)
                  },
                  expression: "ruleForm.crud_id",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "关联应用:", prop: "region" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    multiple: "",
                    filterable: "",
                    size: "small",
                    placeholder: "请搜索选择应用（多选）",
                  },
                  model: {
                    value: _vm.ruleForm.cate_ids,
                    callback: function ($$v) {
                      _vm.$set(_vm.ruleForm, "cate_ids", $$v)
                    },
                    expression: "ruleForm.cate_ids",
                  },
                },
                _vm._l(_vm.cateOptions, function (v, index) {
                  return _c("el-option", {
                    key: v.id,
                    attrs: { label: v.name, value: v.id },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "实体说明:", prop: "region" } },
            [
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  autosize: { minRows: 4, maxRows: 8 },
                  size: "small",
                },
                model: {
                  value: _vm.ruleForm.info,
                  callback: function ($$v) {
                    _vm.$set(_vm.ruleForm, "info", $$v)
                  },
                  expression: "ruleForm.info",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    size: "small",
                    loading: _vm.loading,
                  },
                  on: { click: _vm.submit },
                },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }